export const useStyles = () => {
    return {
        times: {
            display: 'flex',
            flexDirection: 'column',
            gap: 4,
            paddingBottom: '20px'
        },
        footer: {
            display: 'flex',
            justifyContent: 'end'
        },
        switch: {
            marginLeft: 0,
            gap: 2
        },
        container: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2
        },
        containerSelect: {
            minHeight: '60px',
            maxWidth: '300px'
        },
        checkIcon: {
            fontSize: '2.5rem',
            width: '45px',
            height: '45px',
            color: 'c_green.main'
        },
        modalContainer: {
            '&.container': {
                marginBottom: '10px',
            }
        }
    }
}